import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import LoadingScreen from '../../components/LoadingScreen';

class PolicyRedirection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.handlePolicyRedirection();
  }

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  createAxiosInstance() {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_API_URL,
      timeout: 50000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    instance.interceptors.request.use(
      (config) => config,
      (error) => {
        if (
          error.code === "ECONNABORTED" ||
          (error.response && error.response.status === 408)
        ) {
          console.log("httpManager networkTimeOutError");
        } else {
          return Promise.reject(error);
        }
      }
    );

    return instance;
  }

  handlePolicyRedirection = async () => {
    try {
      // Extract token from URL
      const urlParams = this.getUrlVars();
      const token = urlParams['token'];

      if (!token) {
        console.error('No token found in URL');
        this.setState({ 
          error: 'Invalid token',
          isLoading: false 
        });
        return;
      }

      console.log('PolicyRedirection token:', token);

      // Create axios instance and call API
      const axiosInstance = this.createAxiosInstance();
      const response = await axiosInstance.post(
        'api/LoginApi/RetrievePolicyRedirection',
        { Token: token }
      );

      console.log('API Response:', response.data);

      // Check if response is successful
      if (response.data && response.data.Success) {
        const { PolicyNumber, TransactionType, CntType, BearerToken, DeepLink } = response.data.Data;

        // Store data in localStorage
        if (BearerToken) {
          localStorage.setItem("MyToken", BearerToken);
        }
        if (PolicyNumber) {
          localStorage.setItem("PolicyNumber", PolicyNumber);
        }
        if (CntType) {
          localStorage.setItem("locCntType", CntType);
        }
        if (TransactionType) {
          localStorage.setItem("TransactionType", TransactionType);
        }
        if (DeepLink) {
          localStorage.setItem("mobileDeepLink", DeepLink);
          localStorage.setItem("DeepLink", DeepLink);
        }

        localStorage.setItem("TransactionNo", 1);
        localStorage.setItem("ExpiryWarning",10);
        localStorage.setItem("ExpiryEnd",15);

        // Redirect based on transaction type
        // You can customize this logic based on your requirements
        if (TransactionType && PolicyNumber) {
          // Redirect to CustomerPortal with parameters
          const redirectUrl = `${process.env.REACT_APP_TIQ_BASE_URL}/#/?loginToken=${BearerToken}&cntType=${CntType}&actionType=${TransactionType}&source=policyRedirection&deepLink=${DeepLink}`;
          
          // Or redirect to RPILP directly
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 200);
        } else {
          // Default redirect to home
          setTimeout(() => {
            window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
          }, 500);
        }
      } else {
        // Handle error response
        const errorMsg = response.data?.Message || 'Failed to retrieve policy redirection';
        console.error('API Error:', errorMsg);
        this.setState({ 
          error: errorMsg,
          isLoading: false 
        });
      }
    } catch (error) {
      console.error('Error in handlePolicyRedirection:', error);
      this.setState({ 
        error: error.message || 'An error occurred',
        isLoading: false 
      });
    }
  };

  render() {
    const { isLoading, error } = this.state;

    if (error) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '20px',
          backgroundColor: '#FFFFFF',
          boxSizing: 'border-box',
          width:"100%"
        }}>
          <div style={{
            maxWidth: '600px',
            width: '100%',
            textAlign: 'center',
            padding: '0 15px',
          }}>
            <h2 style={{ 
              color: '#F46A6A', 
              marginBottom: '20px',
              fontSize: 'clamp(20px, 5vw, 28px)',
              fontWeight: '600',
              margin: '0 0 20px 0',
            }}>
              Error
            </h2>
            <p style={{ 
              fontSize: 'clamp(14px, 4vw, 16px)', 
              color: '#2c3034',
              lineHeight: '1.6',
              margin: '0 0 30px 0',
              wordWrap: 'break-word',
            }}>
              {error}
            </p>
            <button 
              onClick={() => window.location.href = process.env.REACT_APP_LOGIN_BASE_URL}
              style={{
                width: '100%',
                maxWidth: '300px',
                padding: '12px 24px',
                backgroundColor: '#00B4AF',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: 'clamp(14px, 4vw, 16px)',
                fontWeight: '500',
                boxShadow: '0 2px 8px rgba(0, 180, 175, 0.2)',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#009690';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 180, 175, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#00B4AF';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(0, 180, 175, 0.2)';
              }}
              onTouchStart={(e) => {
                e.target.style.backgroundColor = '#009690';
              }}
              onTouchEnd={(e) => {
                e.target.style.backgroundColor = '#00B4AF';
              }}
            >
              Return to Login
            </button>
          </div>
        </div>
      );
    }

    return <LoadingScreen message="Processing your request..." />;
  }
}

export default withRouter(PolicyRedirection);
